export default "__VITE_ASSET__Dgl1pu5H__"